import { copy } from "../../lib/copy";
import { cn } from "@/lib/utils";

/**
 * Loading is a skeleton matching the final layout, so nothing shifts when the
 * data lands. Static — no shimmer, no pulse: the motion budget is four
 * animations and all four are on the task list.
 *
 * `Skeleton` is blocks of given heights, for a screen that has not been laid
 * out piece by piece yet. `SkeletonBar` and `SkeletonCircle` are the pieces
 * for one that has: a bar stands in for a line of text, a ring for a check.
 */
export function Skeleton({ rows }: { rows: readonly string[] }) {
  return (
    <div aria-busy="true" aria-label={copy.states.loading} className="flex flex-col gap-2">
      {rows.map((height, i) => (
        <div key={i} className={cn("rounded-card bg-line/60", height)} />
      ))}
    </div>
  );
}

/** A line of text that has not arrived. Width is the caller's, as a class. */
export function SkeletonBar({ className }: { className?: string }) {
  return <span aria-hidden className={cn("block h-3 rounded-pill bg-line", className)} />;
}

/** A check circle that has not arrived — the ring only, in `line`. */
export function SkeletonCircle() {
  return <span aria-hidden className="block size-5.5 rounded-pill border-[1.5px] border-line" />;
}
